// tslint:disable:max-line-length
import * as React from 'react';

export const featureVideo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fill="#FFF" fillRule="nonzero" d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-4.4 8.8l-4 3c-.6.5-1.6 0-1.6-.8V5c0-.8.9-1.3 1.6-.8l4 3c.5.4.5 1.2 0 1.6z"/>
  </svg>
);
// tslint:enable:max-line-length
